import { type ReactNode } from "react";
import { Layout as RALayout, CheckForApplicationUpdate } from "react-admin";

import { AppBar } from "@/components/AppBar";
import { Sidebar } from "@/components/Sidebar";

export const Layout = ({ children }: { children: ReactNode }) => (
  <RALayout
    sx={{ "& .RaLayout-content": { pb: 2 } }}
    sidebar={Sidebar}
    appBar={AppBar}
  >
    {children}
    <CheckForApplicationUpdate />
  </RALayout>
);
